/*
 * SPDX-FileCopyrightText: 2022 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { I18nConfig, I18nModule, provideConfig, UrlModule } from '@spartacus/core';
import {
  FormErrorsModule,
  GenericLinkModule,
  MediaModule,
  OutletModule,
  OutletRefModule,
  PageLayoutModule,
  PageSlotModule,
  SpinnerModule
} from '@spartacus/storefront';
import { HeaderComponent } from './header.component';

@NgModule({
  imports: [
    CommonModule,
    PageLayoutModule,
    OutletModule,
    OutletRefModule,
    PageSlotModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    UrlModule,
    I18nModule,
    FormErrorsModule,
    SpinnerModule,
    GenericLinkModule,
    MediaModule,
  ],
  providers: [
    // provideConfig(<I18nConfig>{
    //   i18n: {
    //     resources: translationResource,
    //     chunks: headerTranslationChuncksConfig,
    //     fallbackLang: 'en',
    //   },
    // }),
  ],
  declarations: [HeaderComponent],
})
export class HeaderModule { }


